import React from 'react';
import SEOHead from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';

const ImprintPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Impressum"
        description="Impressum der EU AI Act Training Platform - KI Navigatoren GmbH. Kontaktinformationen und rechtliche Angaben."
        keywords={['Impressum', 'Kontakt', 'Rechtliches', 'KI Navigatoren']}
        canonicalUrl="/impressum"
        noIndex={true}
      />
      <BreadcrumbSchema items={[
        { name: 'Startseite', url: '/' },
        { name: 'Impressum', url: '/impressum' }
      ]} />
      <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Impressum</h1>
          
          <div className="prose max-w-none text-gray-600">
            <div className="mb-8">
              <p className="font-bold">KI Navigatoren GmbH</p>
              <p>Mittelhofer Weg 24</p>
              <p>73466 Lauchheim</p>
              <p>Deutschland</p>
            </div>

            <div className="mb-8">
              <p>Telefon: +49 (0) 7363 8189409</p>
              <p>E-Mail: aiko@ki-navigatoren.de</p>
            </div>

            <div className="mb-8">
              <p className="font-bold mb-2">Vertreten durch die Geschäftsführung:</p>
              <ul className="list-disc pl-5">
                <li>Robert Weber</li>
                <li>Marko Bauer</li>
              </ul>
            </div>

            <div className="mb-8">
              <p>Handelsregister: HRB 750033, Handelsregister B des Amtsgerichts Ulm</p>
              <p>Umsatzsteuer-ID (§ 27a UStG): DE455861126</p>
            </div>

            <div className="mb-8">
              <p className="font-bold mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</p>
              <p>Robert Weber, Anschrift wie oben.</p>
            </div>

            <div className="mb-8">
              <p className="font-bold mb-2">Online-Streitbeilegung / Verbraucherstreitbeilegung</p>
              <p className="mb-2">
                Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p>
                Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ImprintPage;